import React from "react";
import {Dialog} from "@material-ui/core";
import "./index.scss"
import {Button} from "../../Button";
import {strings} from "../../../strings/strings";
import {
    findVehicleGroup,
    IVehicleAndPrimaryInsured,
    Vehicle,
    VehicleColour,
    VehicleGroupNames
} from "../../../model/vehicle";
import {ReactSVG} from "react-svg";
import car from "../../../images/car.svg";


interface IChooseVehicleByPhoneNumberDialogProps {
    isOpen: boolean;
    onSubmit: (selected: IVehicleAndPrimaryInsured) => void;
    onCancel: () => void;
    foundVehicles: Array<IVehicleAndPrimaryInsured>
}

export const ChooseVehicleByPhoneNumberDialog = (props: IChooseVehicleByPhoneNumberDialogProps) => {
    const {isOpen, onSubmit, foundVehicles, onCancel} = props;

    const getVehicleDescription = (vehicle: Vehicle) => {
        return vehicle.constructionYear.toString() + ", " + vehicle.brand.name + ((vehicle.colour && VehicleColour[vehicle.colour]) ? (", " + VehicleColour[vehicle.colour]) : "");
    };

    return (
        <Dialog open={isOpen} disableBackdropClick={true}>
            <div className={"dialog choose-vehicle-by-phone-number-dialog"}>
                <div className="dialog__content">
                    <span
                        className={"dialog__title choose-vehicle-by-phone-number-dialog__title"}>{strings.chooseFromSelected}</span>

                    <div className="choose-vehicle-by-phone-number-dialog__items">
                        {
                            <div className="choose-vehicle-by-phone-number-dialog__item">
                                <div className={"vs-dialog__content__vehicles"}>
                                    {foundVehicles?.map((value, index) => {
                                        return (
                                            <div key={index} className={"vs-dialog__content__vehicles__item"}
                                                 onClick={() => onSubmit(value)}
                                            >
                                                <div className={"vs-dialog__content__vehicles__item__image"}>
                                                    <ReactSVG src={car}/>
                                                </div>
                                                <div className={"vs-dialog__content__vehicles__item__type"}>
                                                    <span>{VehicleGroupNames[findVehicleGroup(value.vehicle.vehicleType)]}</span>
                                                </div>
                                                <div className={"vs-dialog__content__vehicles__item__description"}>
                                                    <span> {getVehicleDescription(value.vehicle)}</span>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>

                        }
                    </div>

                    <Button label={strings.toolbarManual}
                            onClickListener={onCancel}/>
                </div>
            </div>
        </Dialog>
    )

}